export const defaultWifiData: WifiModel = {
  ishidden: false,
  ssid: '',
  password: '',
  encryption: '',
};
